<template>
  <div class="container">
    <main>
      <h1 class="page-title">利用規約</h1>
      <div class="terms-content">
        <h2>第1条 本利用規約について</h2>
        <p>「お支度ボード利用規約」（以下「本利用規約」といいます。）は、お支度ボード（以下「当運営者」といいます。）が当運営者の提供するすべてのサービス（以下「本サービス」といいます。）の利用条件を定めるものです。本サービスをご利用される場合には、本利用規約に同意したものとみなされます。</p>
        <p>当運営者は、個別のサービスにおいて個別の規約（以下「個別規約」といいます。）を定めています。個別規約も名称の如何にかかわらず本利用規約の一部を構成するものとします。</p>
        <p>お支度ボード利用規約の定めと個別規約の定めが異なる場合には、当該個別規約の定めが優先して適用されるものとします。</p>
        <p>当運営者は、相当の事由があると判断した場合には、利用者の事前の承諾を得ることなく、当運営者の判断により、本利用規約をいつでも変更することができるものとします。</p>

        <h2>第2条 定義</h2>
        <p>本利用規約において使用する用語の意義は、次の各号に定めるとおりとします。</p>
        <ol>
          <li>「利用者」とは、本サービスを利用する全ての方をいいます。</li>
          <li>「登録者」とは、第３条２項に基づきユーザー登録手続きを行い本サービスを利用する方をいいます。</li>
          <li>「ユーザー登録」とは、お支度ボードのユーザーとして当運営者のサーバーに登録されることをいいます。</li>
          <li>「企業・団体」とは、法人、組合、サークル等の自然人が所属する組織をいいます。</li>
        </ol>

        <h2>第3条 ユーザー登録</h2>
        <p>ユーザー登録を希望する利用者は、本利用規約に同意の上、当運営者所定の登録手続きを行っていただきます。</p>
        <p>当運営者は、前項の手続きに沿って入力されたお申込み内容につき必要な審査を行い、申込者のユーザー登録を承諾する場合、当該お申込み内容を登録情報として登録します。</p>

        <h2>第4条 企業・団体登録</h2>
        <p>企業・団体登録を希望する利用者は、本利用規約に同意の上、当運営者所定の登録手続きを行っていただきます。</p>

        <h2>第5条 有料サービス</h2>
        <p>本サービスのうち当運営者が有料機能によって提供する有料サービスをご利用される場合には、別途定める有料サービスに関する利用規約の定めに従うものとします。</p>

        <h2>第6条 メールアドレスおよびパスワードの管理</h2>
        <p>登録者は、メールアドレスおよびパスワードについて、自己の責任の下で管理を行うものとし、登録情報が不正確または虚偽であったために登録者が被った一切の不利益および損害に関し、当運営者は一切の責任を負わないものとします。</p>
        <p>当運営者は、ログイン時に入力されたメールアドレスおよびパスワードが、登録されたメールアドレスおよびパスワードと一致することを所定の方法により確認した場合、当該ログインを真正な登録者のログインとみなし、登録者による利用とみなします。</p>

        <h2>第7条 個人情報の取扱い等</h2>
        <p>当運営者は、当運営者が取得した個人情報に関し、別途定めるプライバシーポリシーに基づき、適切に取り扱うものとします。</p>

        <h2>第8条 届出情報の変更、ユーザー登録の解除等</h2>
        <p>登録者は、届出情報に変更があった場合、すみやかに当運営者の定める手続きにより当運営者に届け出るものとします。この届出がない場合、当運営者は届出情報の変更がないものとして取り扱います。</p>
        <p>登録者からの届出情報の変更の届出がないために、当運営者からの通知、その他が遅延し、または不着、不履行であった場合、当運営者はその責任を負わないものとします。</p>

        <h2>第9条 譲渡禁止等</h2>
        <p>登録者は、本サービスに関する権利について、第三者に譲渡し、または質権の設定その他の担保に供する等の行為ができないものとします。</p>
        <p>登録者の地位は、当運営者が指定する方法により企業・団体登録をした登録者の地位を企業・団体の構成員である別の登録者に承継する場合及び当運営者が別途指定する場合を除き、売買、名義変更および承継することはできないものとします。</p>

        <h2>第10条 連絡または通知</h2>
        <p>登録者への連絡または通知の必要があると当運営者が判断した場合には、登録されたメールアドレス宛にメールにて連絡または通知を行います。</p>
        <p>利用者は、本利用規約に別段の定めがある場合を除き、当運営者への連絡はお問い合わせフォームから行うものとします。当運営者は電話による連絡および来訪は受け付けておりません。</p>

        <h2>第11条 本サービスの提供の中断等</h2>
        <p>当運営者は、以下のいずれかの事由が生じた場合には、利用者に事前に通知することなく、一時的に本サービスの全部または一部の提供を中断することがあります。</p>
        <ol>
          <li>本サービスを提供するための通信設備等の定期的な保守点検を行う場合または点検を緊急に行う場合</li>
          <li>火災、停電等により本サービスの提供ができなくなった場合</li>
          <li>地震、噴火、洪水、津波等の天災により本サービスの提供ができなくなった場合</li>
          <li>戦争、動乱、暴動、騒乱、労働争議等により本サービスの提供ができなくなった場合</li>
          <li>その他、運用上または技術上、当運営者が本サービスの提供の一時的な中断を必要と判断した場合</li>
        </ol>

        <h2>第12条 利用環境の整備</h2>
        <p>利用者は、本サービスを利用するために必要な通信機器、ソフトウェアその他これらに付随して必要となる全ての機器を、自己の費用と責任において準備し、利用可能な状態に置くものとします。</p>
        <p>利用者は、関係官庁等が提供する情報を参考にして、自己の利用環境に応じ、コンピュータ・ウィルスの感染、不正アクセスおよび情報漏洩の防止等セキュリティを保持するものとします。</p>

        <h2>第13条 自己責任の原則</h2>
        <p>利用者は、利用者自身の自己責任において本サービスを利用するものとし、本サービスを利用してなされた一切の行為およびその結果についてその責任を負うものとします。</p>

        <h2>第14条 知的財産権等</h2>
        <p>利用者は、利用者が送信（発信）したコンテンツにつき、当運営者に対して、当運営者または当運営者の指定する者が当該コンテンツを日本国内外問わず対価の支払いなく非独占的にいかなる制約も受けずに自由に使用する権利を許諾したものとみなされるものとします。</p>

        <h2>第15条 当運営者の財産権</h2>
        <p>利用者が送信（発信）したコンテンツおよび情報を除き、本サービスに含まれる一切のコンテンツおよび情報に関する財産権は当運営者に帰属します。</p>

        <h2>第16条 禁止事項</h2>
        <p>利用者は、本サービスの利用に際して、以下の行為を行ってはならないものとします。</p>
        <ol>
          <li>当運営者、他の利用者もしくはその他の第三者の著作権、商標権等の知的財産権を侵害する行為</li>
          <li>他者の財産、プライバシーもしくは肖像権を侵害する行為</li>
          <li>特定の個人の個人情報の提供</li>
          <li>一人の利用者が複数の登録者の地位を保有する行為</li>
          <li>本サービスの運営を妨害する行為、または当運営者の信用を毀損する行為</li>
          <li>本サービスを商業目的で利用する行為（当運営者が許可した場合を除く）</li>
          <li>当運営者の許可なく本サービスを複製、改変、リバースエンジニアリングする行為</li>
          <li>その他、当運営者が不適切と判断する行為</li>
        </ol>

        <h2>第17条 ユーザー登録解除等</h2>
        <p>当運営者は、利用者の行為が本利用規約に反すると判断した場合には、当運営者の判断により、当該利用者に何ら通知することなくして、サービスの一時停止、ユーザー登録の解除をすることができるものとします。</p>

        <h2>第18条 利用制限</h2>
        <p>当運営者は、当該利用者の承諾を得ることなく、当該利用者の本サービスの利用を制限することがあります。</p>

        <h2>第19条 免責</h2>
        <p>当運営者は、以下の事項について一切の責任を負わないものとします。</p>
        <ol>
          <li>本サービスの利用により発生した利用者の損害</li>
          <li>本サービスの停止、中断、変更、終了による損害</li>
          <li>利用者が登録したデータの消失、破損</li>
          <li>利用者間のトラブルに起因する損害</li>
          <li>第三者による不正アクセスや情報改竄による損害</li>
          <li>その他本サービスに関連して発生した損害</li>
        </ol>

        <h2>第20条 開発中のサービスについて</h2>
        <p>当運営者は、本サービスの一部または独立したサービスとして、開発中のサービスを提供することができるものとします。</p>

        <h2>第21条 準拠法</h2>
        <p>本規約は、日本法に準拠し、解釈されるものとします。</p>

        <h2>第22条 裁判管轄</h2>
        <p>利用者と当運営者との間で訴訟の必要が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'TermsView',
  mounted() {
    document.title = '利用規約 | お支度ボードアプリ'
  }
}
</script>

<style>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.page-title {
  display: block;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: bold;
  color: #1a202c;
}

.terms-content {
  max-width: none;
  text-align: left;
}

.terms-content h2 {
  margin-top: 2em;
  margin-bottom: 1em;
  font-weight: bold;
}

.terms-content p {
  margin-bottom: 1em;
  line-height: 1.8;
}

.terms-content ol {
  margin-left: 1.5em;
  margin-bottom: 1em;
}

.terms-content li {
  margin-bottom: 0.5em;
}

.terms-content ul {
  list-style-type: disc;
  margin-left: 1.5em;
  margin-bottom: 1em;
}
</style> 